/** Name to display for credit */
export const CREDIT_DISPLAY_NAME = "token";

/** Name to display for credits */
export const CREDITS_DISPLAY_NAME = "tokens";